export const FONTS = [
  "Cormorant Garamond", "Jost", "Playfair Display", "Libre Baskerville", "Lora", "EB Garamond", "Cinzel", "Bodoni Moda",
  "DM Serif Display", "Marcellus", "Montserrat", "Lato", "Raleway", "Poppins", "Work Sans", "Nunito Sans", "Josefin Sans", "Julius Sans One",
];

export const ELEMENTS: { k: string; label: string; sel: string; sample: string }[] = [
  { k: "h1", label: "Page titles (H1)", sel: "h1", sample: "Engagement Rings" },
  { k: "h2", label: "Section headings (H2)", sel: "h2", sample: "Who Qualifies" },
  { k: "h3", label: "Sub-headings (H3/H4)", sel: "h3, h4", sample: "Product name" },
  { k: "body", label: "Body text", sel: "p, li, [data-testid='site-footer'] a", sample: "Every Somnio.Co piece is crafted from dreams." },
  { k: "eyebrow", label: "Small caps labels", sel: ".eyebrow", sample: "New arrivals" },
  { k: "nav", label: "Main menu", sel: "[data-testid='desktop-nav'] a", sample: "Engagement" },
  { k: "announcement", label: "Announcement bar", sel: "[data-testid='announcement-bar']", sample: "Free insured shipping" },
];

const loaded = new Set<string>(["Cormorant Garamond", "Jost", "Julius Sans One"]);
const loadFont = (f?: string) => {
  if (!f || loaded.has(f) || !FONTS.includes(f)) return;
  loaded.add(f);
  const l = document.createElement("link");
  l.rel = "stylesheet";
  l.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(f).replace(/%20/g, "+")}:wght@300;400;500;600;700&display=swap`;
  document.head.appendChild(l);
};

const fam = (f: string) => `"${f.replace(/"/g, "")}", ${/Sans|Jost|Montserrat|Lato|Raleway|Poppins|Nunito/.test(f) ? "sans-serif" : "serif"}`;

export function typographyCss(t: any): string {
  if (!t) return "";
  const out: string[] = [];
  const S = ".storefront";
  if (t.heading_font) { loadFont(t.heading_font); out.push(`${S} .font-display, ${S} h1, ${S} h2, ${S} h3 { font-family: ${fam(t.heading_font)} !important; }`); }
  if (t.body_font) { loadFont(t.body_font); out.push(`${S} { font-family: ${fam(t.body_font)}; }`); }
  if (t.heading_color) out.push(`${S} h1, ${S} h2, ${S} h3, ${S} h4 { color: ${t.heading_color} !important; }`);
  if (t.link_hover_color) out.push(`${S} a:hover { color: ${t.link_hover_color} !important; }`);
  for (const e of ELEMENTS) {
    const v = t.elements?.[e.k];
    if (!v) continue;
    const sel = e.sel.split(",").map((x) => `${S} ${x.trim()}`).join(", ");
    const r: string[] = [];
    if (v.font) { loadFont(v.font); r.push(`font-family: ${fam(v.font)} !important`); }
    if (v.size) r.push(`font-size: ${Number(v.size)}px !important`);
    if (v.weight) r.push(`font-weight: ${Number(v.weight)} !important`);
    if (v.spacing !== undefined && v.spacing !== "") r.push(`letter-spacing: ${Number(v.spacing)}em !important`);
    if (v.case) r.push(`text-transform: ${v.case} !important`);
    if (v.color) r.push(`color: ${v.color} !important`);
    if (r.length) out.push(`${sel} { ${r.join("; ")}; }`);
    if (v.size_mobile) out.push(`@media (max-width: 767px) { ${sel} { font-size: ${Number(v.size_mobile)}px !important; } }`);
  }
  return out.join("\n");
}
